import { HTTP_INTERCEPTORS, provideHttpClient, withFetch, withInterceptorsFromDi } from '@angular/common/http';
import { ApplicationConfig, ErrorHandler, importProvidersFrom } from '@angular/core';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter, TitleStrategy } from '@angular/router';
import { ServiceWorkerModule } from '@angular/service-worker';

import { provideAngularSvgIcon } from 'angular-svg-icon';
import player, { LottiePlayer } from 'lottie-web';
import { provideLottieOptions } from 'ngx-lottie';
import { provideEnvironmentNgxMask } from 'ngx-mask';
import { NgxPermissionsModule } from 'ngx-permissions';

import { HttpErrorInterceptor } from '@core/interceptors/http-error.interceptor';
import { RefreshTokenInterceptor } from '@core/interceptors/refresh-token.interceptor';
import { TokenInterceptor } from '@core/interceptors/token.interceptor';
import { GlobalErrorHandler } from '@core/services/global-error-handler';
import { CustomPageTitleStrategy } from '@shared/helpers/title-strategy';
import { environment } from '@environments/environment';

import { routes } from '../app.routes';

import { provideTranslateService } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';

export function playerFactory(): LottiePlayer {
  return player;
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideEnvironmentNgxMask(),
    provideRouter(routes),
    importProvidersFrom([
      NgxPermissionsModule.forRoot(),
      ServiceWorkerModule.register('ngsw-worker.js', {
        enabled: environment.production,
        registrationStrategy: 'registerWhenStable:30000',
      }),
    ]),
    provideHttpClient(withFetch(), withInterceptorsFromDi()),
    provideLottieOptions({ player: playerFactory }),
    provideAngularSvgIcon(),
    provideTranslateService({
      loader: provideTranslateHttpLoader({ prefix: './assets/i18n/', suffix: '.json' }),
    }),
    provideAnimations(),
    { provide: TitleStrategy, useClass: CustomPageTitleStrategy },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpErrorInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: RefreshTokenInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true,
    },
    { provide: ErrorHandler, useClass: GlobalErrorHandler },
  ],
};
